import React, { useState } from 'react';
import { AvatarUpload } from './AvatarUpload';

export function AvatarUploadExample(): JSX.Element {
  const [image, setImage] = useState<string | undefined>(undefined);

  function handleImageChange(file?: File): void {
    if (!file) {
      return setImage(undefined);
    }
    const reader = new FileReader();

    reader.readAsDataURL(file);

    reader.onload = () => {
      if (reader.result && typeof reader.result === 'string') {
        setImage(reader.result);
      }
    };
  }

  return (
    <div>
      <AvatarUpload
        image={image}
        onChange={handleImageChange}
        label="Lorem ipsum dolor sit amet consectetur adipisicing elit."
      />
    </div>
  );
}
